import { ReactElement } from 'react';
import { flatten, isEmpty } from 'lodash';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TapTooltip from '../TapTooltip';
import { departmentSettingKeys } from '../../variables/Department';

interface DepartmentSettingsTooltipProps {
  departmentSettings: { [key: string]: number };
  children: ReactElement<any, any>;
  mobile?: boolean;
}

const DepartmentSettingsTooltip = (props: DepartmentSettingsTooltipProps) => {
  const { t } = useTranslation();

  const availableKeys = departmentSettingKeys.filter((key) =>
    Object.keys(props.departmentSettings).includes(key),
  );

  return isEmpty(availableKeys) ? (
    <></>
  ) : (
    <TapTooltip
      mobile={props.mobile}
      title={
        <Typography>
          {flatten(
            availableKeys.map((key) => [
              `${t(
                `department.department_settings.${key}`,
              )}: ${props.departmentSettings[key].toString()}`,
              <br />,
            ]),
          )}
        </Typography>
      }
    >
      {props.children}
    </TapTooltip>
  );
};

export default DepartmentSettingsTooltip;
